import { render, staticRenderFns } from "./ActiveComponent.vue?vue&type=template&id=2f570758"
import script from "./ActiveComponent.vue?vue&type=script&lang=ts"
export * from "./ActiveComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports